
import Vuex from 'vuex'




export const store =  new Vuex.Store({
	state: {
		rightView: 'product-includes-main',
		prop1: '',
		prop2: '',
		prop3: [],

		prodID: '',

		productList: [],
		productComp: '0',

		detailsList: [],
		detailsComp: '0',

		includeList: [],
		includeComp: '0',

		productItemList: [],
		productItemComp: '0',

		itemList: [],
		itemComp: '0',

	},

	mutations: {
		setRightView(state, payload) { state.rightView = payload.name; state.prop1 = payload.prop1; state.prop2 = payload.prop2; state.prop3 = payload.prop3 },

		setProducts(state, payload) { state.productList = payload.info; state.productComp = payload.info1; },
		setProductsComp(state, payload) { state.productComp = payload.info1; },

		setDetails(state, payload) { state.detailsList = payload.info; state.detailsComp = payload.info1; },
		setDetailsComp(state, payload) { state.detailsComp = payload.info1; },

		setProductIncludes(state, payload) { state.includeList = payload.info; state.includeComp = payload.info1; },
		setProductIncludesComp(state, payload) { state.includeComp = payload.info1; },

		setProductItems(state, payload) { state.productItemList = payload.info; state.productItemComp = payload.info1; },
		setProductItemsComp(state, payload) { state.productItemComp = payload.info1; },

		setItems(state, payload) { state.itemList = payload.info; state.itemComp = payload.info1; },
		setItemsComp(state, payload) { state.itemComp = payload.info1; },
		
		setProductID(state, payload) { state.prodID = payload.prod },
  	},

	actions: {
		getRightView(context, payload) { context.commit("setRightView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2, prop3: payload.prop3 })  },
		getProductDetails(context, payload) {
			context.commit("setDetailsComp", { info1: '0' }) 
			axios.get('/admin/utility/product/getproductdetails/' + payload.prod)
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setDetails", { info: b, info1: '1' }) 
	          	});
	    },
	    getProductIncludes(context, payload) {
			context.commit("setProductIncludesComp", { info1: '0' }) 
			axios.get('/admin/utility/product/getproductincludes/' + payload.prod)
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setProductIncludes", { info: b, info1: '1' }) 
	          	});
	    },
	    getAllProductItems(context, payload) {
			context.commit("setProductItemsComp", { info1: '0' }) 
			axios.get('/admin/utility/product/getproductitems/' + payload.prod)
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setProductItems", { info: b, info1: '1' }) 
	          	});
	    },
	    getAllItems(context, payload) {
			context.commit("setItemsComp", { info1: '0' }) 
			axios.get('/admin/utility/product/getallitems')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setItems", { info: b, info1: '1' }) 
	          	});
	    }
		
		
	}

})